import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const ChatMessage = ({ message }) => {
  // Process text to properly format markdown
  const processMessageText = (text) => {
    if (!text) return "";
    
    // First, clean up any existing formatting issues
    let processedText = text.trim();
    
    // Enhanced markdown formatting logic
    processedText = processedText
      // Ensure proper paragraph spacing by first normalizing line breaks
      .replace(/\r\n/g, '\n')

      // Convert ASCII dividers (====... or ----...) to markdown hr
      .replace(/^[=]{4,}\s*$/gm, '---')
      .replace(/^[-]{4,}\s*$/gm, '---')
      
      // Add proper spacing for headings (ensure they have a blank line before)
      .replace(/([^\n])\n(#{1,6}\s)/g, '$1\n\n$2')
      
      // Ensure paragraphs have proper spacing
      .replace(/\n\n+/g, '\n\n')
      
      // Fix list formatting (ensure proper spacing before and after lists)
      .replace(/([^\n])\n([-*+]\s)/g, '$1\n\n$2')
      .replace(/([^\n])\n(\d+\.\s)/g, '$1\n\n$2')
      
      // Add proper line breaks within paragraphs by using the double space method
      .replace(/([^\n])\n([^#\s\n-*+\d])/g, '$1  \n$2');
    
    return processedText;
  };

  // Handle different message types (user, ai, system)
  return (
    <div className={`chat-message ${message.sender}`}>
      <div className="message-bubble">
        {message.sender === 'system' && (
          <span className="system-message-indicator">System: </span>
        )}
        
        {/* Render AI messages with markdown */}
        {message.sender === 'ai' ? (
          <div className="markdown-content">
            {message.text ? (
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
                components={{
                  // Add custom styling to paragraphs to ensure proper spacing
                  p: ({ node, children, ...props }) => (
                    <p style={{ marginBottom: '1em' }} {...props}>{children}</p>
                  ),
                  // Add custom styling to headings
                  h1: ({ node, children, ...props }) => (
                    <h1 style={{ marginTop: '1.5em' }} {...props}>{children}</h1>
                  ),
                  h2: ({ node, children, ...props }) => (
                    <h2 style={{ marginTop: '1.5em' }} {...props}>{children}</h2>
                  ),
                  h3: ({ node, children, ...props }) => (
                    <h3 style={{ marginTop: '1.5em' }} {...props}>{children}</h3>
                  )
                }}
              >
                {processMessageText(message.text)}
              </ReactMarkdown>
            ) : (
              <span>No response content</span>
            )}
          </div>
        ) : (
          // Render user and system messages as plain text with preserved newlines
          <span style={{ whiteSpace: 'pre-wrap' }}>{message.text || ""}</span>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;